module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/emos//feed.gif?v=f35e324e";